import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "分类"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      multiple: ""
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.categories,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "categories", $$v);
      },
      expression: "searchForm.categories"
    }
  }, _vm._l(_vm.categoryList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索 ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          page: 1,
          limit: 20
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置 ")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "编号",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-community-table-link", {
          attrs: {
            id: scope.row.id,
            token: scope.row.token,
            title: scope.row.code
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.name",
      label: "姓名",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfo = _ref.row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "备注",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$user;
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: ((_scope$row$user = scope.row.user) === null || _scope$row$user === void 0 ? void 0 : _scope$row$user.remarkList) || [],
            remark: scope.row.user.remark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.gender",
      label: "性别",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.user.gender == "0" ? _c("span", [_vm._v("未知")]) : _vm._e(), scope.row.user.gender == "1" ? _c("span", [_vm._v("男")]) : _vm._e(), scope.row.user.gender == "2" ? _c("span", [_vm._v("女")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.phone",
      label: "手机号",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-community-table-link", {
          attrs: {
            id: scope.row.id,
            token: scope.row.token,
            title: scope.row.title
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "classify",
      label: "分类",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var category_names = _ref2.row.category_names;
        return _vm._l(category_names, function (tag, index) {
          return _c("el-tag", {
            key: index,
            staticStyle: {
              margin: "3px"
            },
            attrs: {
              size: "small"
            }
          }, [_vm._v(_vm._s(tag) + " ")]);
        });
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "地址",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var _ref3$row = _ref3.row,
          location = _ref3$row.location,
          location_city = _ref3$row.location_city,
          ip_city = _ref3$row.ip_city,
          location_match_status = _ref3$row.location_match_status;
        return [location || location_city ? _c("div", [_c("p", [_vm._v(" " + _vm._s(location_city) + " " + _vm._s(location) + " ")]), ip_city ? _c("el-tag", {
          attrs: {
            type: location_match_status == 2 ? "danger" : "info",
            size: "mini"
          }
        }, [_vm._v(_vm._s(ip_city) + " ")]) : _vm._e()], 1) : _c("div", [ip_city ? _c("el-tag", {
          attrs: {
            type: "info",
            size: "mini"
          }
        }, [_vm._v(_vm._s(ip_city) + " ")]) : _vm._e()], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "开放状态",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == "1" ? _c("span", [_vm._v("未开放")]) : _vm._e(), scope.row.status == "2" ? _c("span", [_vm._v("开放中")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "created_at",
      label: "创建时间",
      width: "160"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "updated_at",
      label: "更新时间",
      width: "160"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "160",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateItem(scope.row);
            }
          }
        }, [_vm._v("编辑 ")]), _c("el-button", {
          staticClass: "wlc-button-succes",
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.audit(scope.row, 1);
            }
          }
        }, [_vm._v("通过 ")]), _c("RejectModal", {
          attrs: {
            placement: "left"
          },
          on: {
            reject: _vm.reject
          }
        }, [_c("el-button", {
          staticClass: "wlc-button-danger",
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setRejectRow(scope.row);
            }
          }
        }, [_vm._v("拒绝 ")])], 1), _c("el-button", {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setRemarkDialog(scope.row.user);
            }
          }
        }, [_vm._v(" 备注 ")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.limit,
      "current-page": _vm.searchForm.page,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("wlc-remark", {
    attrs: {
      visible: _vm.remarkDialogVisible,
      userId: _vm.currentRemarkObj.id,
      remark: _vm.currentRemarkObj.remark
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.remarkDialogVisible = $event;
      },
      getData: _vm.getData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };